import axiosInstance from './AxiosInstance';

export const getWeeklyListingTypeCounts = async () => {
  const response = await axiosInstance.get('/graph/weekly-listing-type-counts');
  return response.data;
};
